/**
 * Push Button Bundle Builder
 *
 * Guided flow: Style > Finish > Plate Size
 * Each ADD click commits to cart immediately (plate + N switches per set,
 * or single plate for upsells). Theme popdown confirms each add.
 */
(function () {
  'use strict';

  // -- Product Handle Catalog --
  var PLATES = {
    Century: {
      '1G': { label: 'Single', switches: 1, handle: 'century-push-button-wall-plate' },
      '2G': { label: 'Double', switches: 2, handle: 'century-push-button-wall-plate-double-gang' },
      '3G': { label: 'Triple', switches: 3, handle: 'century-push-button-wall-plate-triple-gang' },
      '4G': { label: 'Quad',   switches: 4, handle: 'century-push-button-wall-plate-four-gang' }
    },
    Futura: {
      '1G': { label: 'Single', switches: 1, handle: 'futura-push-button-wall-plate' },
      '2G': { label: 'Double', switches: 2, handle: 'futura-push-button-wall-plate-double-gang' },
      '3G': { label: 'Triple', switches: 3, handle: 'futura-push-button-wall-plate-triple-gang' },
      '4G': { label: 'Quad',   switches: 4, handle: 'futura-push-button-wall-plate-four-gang' }
    }
  };

  var SWITCH_HANDLE = 'the-push-button-switch';

  var UPSELL = {
    Century: [
      { label: 'Toggle Plate', handle: 'century-toggle-wall-plate-1', gang: '1G' },
      { label: 'Outlet Plate', handle: 'century-outlet-wall-plate', gang: '1G' },
      { label: 'Open Plate', handle: 'century-open-wall-plate', gang: '1G' },
      { label: 'Blank Plate', handle: 'century-blank-wall-plate', gang: '1G' },
      { label: 'Double Toggle', handle: 'century-toggle-wall-plate-double-gang', gang: '2G' },
      { label: 'Double Outlet', handle: 'century-outlet-wall-plate-double-gang', gang: '2G' },
      { label: 'Double Open', handle: 'century-open-wall-plate-double-gang', gang: '2G' },
      { label: 'Toggle + Outlet', handle: 'century-toggle-outlet-wall-plate-double-gang-1', gang: '2G' },
      { label: 'Toggle + Open', handle: 'century-toggle-open-wall-plate-double-gang', gang: '2G' },
      { label: 'PB + Outlet', handle: 'century-push-button-outlet-wall-plate-double-gang', gang: '2G' },
      { label: 'PB + Open', handle: 'century-push-button-open-wall-plate-double-gang', gang: '2G' },
      { label: 'Open + Outlet', handle: 'century-open-outlet-wall-plate-double-gang', gang: '2G' }
    ],
    Futura: [
      { label: 'Toggle Plate', handle: 'futura-toggle-wall-plate-1', gang: '1G' },
      { label: 'Outlet Plate', handle: 'futura-outlet-wall-plate', gang: '1G' },
      { label: 'Open Plate', handle: 'futura-open-wall-plate', gang: '1G' },
      { label: 'Blank Plate', handle: 'futura-blank-wall-plate', gang: '1G' },
      { label: 'Double Toggle', handle: 'futura-toggle-wall-plate-double-gang', gang: '2G' },
      { label: 'Double Outlet', handle: 'futura-outlet-wall-plate-double-gang', gang: '2G' },
      { label: 'Double Open', handle: 'futura-open-wall-plate-double-gang', gang: '2G' },
      { label: 'Toggle + Outlet', handle: 'futura-toggle-outlet-wall-plate-double-gang-1', gang: '2G' },
      { label: 'Toggle + Open', handle: 'futura-toggle-open-wall-plate-double-gang', gang: '2G' },
      { label: 'PB + Outlet', handle: 'futura-push-button-outlet-wall-plate-double-gang', gang: '2G' },
      { label: 'PB + Open', handle: 'futura-push-button-open-wall-plate-double-gang', gang: '2G' },
      { label: 'Open + Outlet', handle: 'futura-open-outlet-wall-plate-double-gang', gang: '2G' }
    ]
  };

  var FINISHES = {
    Century: [
      { code: 'PB', variant: 'Polished Brass', display: 'Polished Brass' },
      { code: 'SN', variant: 'Brushed Nickel',  display: 'Satin Nickel' },
      { code: 'SB', variant: 'Brushed Brass',   display: 'Satin Brass' }
    ],
    Futura: [
      { code: 'PB',  variant: 'Polished Brass',  display: 'Polished Brass' },
      { code: 'SN',  variant: 'Brushed Nickel',   display: 'Satin Nickel' },
      { code: 'SB',  variant: 'Brushed Brass',    display: 'Satin Brass' },
      { code: 'CBB', variant: 'Coal Black Brass', display: 'Coal Black Brass' }
    ]
  };

  // -- State --
  var state = {
    step: 1,
    style: null,
    finish: null,
    finishDisplay: null,
    finishCode: null,
    firstSetAdded: false,
    products: {},
    loaded: false
  };

  // -- DOM References --
  var dom = {};

  // -- Initialize --
  function init() {
    dom.root = document.getElementById('pushBundle');
    if (!dom.root) return;

    dom.stepper = document.getElementById('pushBundleStepper');
    dom.loading = document.getElementById('pushBundleLoading');
    dom.stylePanel = document.getElementById('pushBundleStylePanel');
    dom.styleCards = document.getElementById('pushBundleStyleCards');
    dom.finishPanel = document.getElementById('pushBundleFinishPanel');
    dom.finishCards = document.getElementById('pushBundleFinishCards');
    dom.setsPanel = document.getElementById('pushBundleSetsPanel');
    dom.setGrid = document.getElementById('pushBundleSetGrid');
    dom.upsell = document.getElementById('pushBundleUpsell');
    dom.upsellGrid = document.getElementById('pushBundleUpsellGrid');
    dom.upsellSubtitle = document.getElementById('pushBundleUpsellSubtitle');

    fetchAllProducts().then(function () {
      state.loaded = true;
      dom.loading.style.display = 'none';
      renderStyleCards();
      setStep(1);
    });

    dom.stepper.addEventListener('click', onStepperClick);
    dom.styleCards.addEventListener('click', onStyleClick);
    dom.finishCards.addEventListener('click', onFinishClick);
    dom.setGrid.addEventListener('click', onGridClick);
    dom.upsellGrid.addEventListener('click', onGridClick);
  }

  // -- Fetch All Products --
  function fetchAllProducts() {
    var handles = [SWITCH_HANDLE];
    ['Century', 'Futura'].forEach(function (style) {
      Object.keys(PLATES[style]).forEach(function (g) { handles.push(PLATES[style][g].handle); });
      UPSELL[style].forEach(function (item) { handles.push(item.handle); });
    });
    handles = handles.filter(function (h, i) { return handles.indexOf(h) === i; });

    var fetches = handles.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (p) state.products[p.handle] = p; })
        .catch(function () {});
    });

    return Promise.all(fetches);
  }

  // -- Step Management --
  function setStep(newStep) {
    state.step = newStep;
    updateStepper();

    dom.stylePanel.style.display = newStep === 1 ? '' : 'none';
    dom.finishPanel.style.display = newStep === 2 ? '' : 'none';
    dom.setsPanel.style.display = newStep === 3 ? '' : 'none';
    dom.upsell.style.display = newStep === 3 && state.firstSetAdded ? '' : 'none';

    if (newStep === 3) {
      renderSetCards();
      renderUpsellCards();
    }

    if (state.loaded) {
      var activePanel = newStep === 1 ? dom.stylePanel :
                        newStep === 2 ? dom.finishPanel : dom.setsPanel;
      if (activePanel) {
        activePanel.classList.add('is-entering');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            activePanel.classList.remove('is-entering');
          });
        });
        setTimeout(function () {
          var stepperBand = document.querySelector('.push-bundle__stepper-band');
          var stickyBottom = stepperBand ? stepperBand.getBoundingClientRect().bottom : 0;
          var panelTop = activePanel.getBoundingClientRect().top;
          window.scrollBy({ top: panelTop - stickyBottom - 8, behavior: 'smooth' });
        }, 50);
      }
    }
  }

  function updateStepper() {
    var steps = dom.stepper.querySelectorAll('.push-bundle__stepper-step');
    for (var i = 0; i < steps.length; i++) {
      var s = parseInt(steps[i].dataset.step);
      steps[i].classList.toggle('is-active', s === state.step);
      steps[i].classList.toggle('is-completed', s < state.step);
      steps[i].disabled = s > state.step;
    }
    var labels = dom.stepper.querySelectorAll('.push-bundle__stepper-text');
    labels[0].textContent = state.style || 'Style';
    labels[1].textContent = state.finishDisplay || 'Finish';
    labels[2].textContent = 'Plate Size';
  }

  // -- Style Selection --
  function renderStyleCards() {
    dom.styleCards.innerHTML =
      buildStyleCard('Century', 'Beveled edges and timeless detailing.') +
      buildStyleCard('Futura', 'Clean lines and a minimal profile.');
  }

  function buildStyleCard(style, desc) {
    var selected = state.style === style ? ' is-selected' : '';
    var handle = PLATES[style]['1G'].handle;
    var product = state.products[handle];
    var img = getWithSwitchImage(product, 'Polished Brass');
    return '<button class="push-bundle__style-card' + selected + '" data-style="' + style + '">' +
      '<div class="push-bundle__style-card-img">' +
        (img ? '<img src="' + getSizedUrl(img, 800) + '" alt="' + style + '" loading="lazy">' : '') +
      '</div>' +
      '<h3 class="push-bundle__style-card-title">' + style + '</h3>' +
      '<p class="push-bundle__style-card-desc">' + desc + '</p>' +
    '</button>';
  }

  function onStyleClick(e) {
    var card = e.target.closest('[data-style]');
    if (!card) return;
    selectStyle(card.dataset.style);
  }

  function selectStyle(style) {
    if (state.style !== style) {
      state.style = style;
      state.finish = null;
      state.finishDisplay = null;
      state.finishCode = null;
    }
    renderStyleCards();
    renderFinishSwatches();
    setStep(2);
  }

  // -- Finish Selection --
  function renderFinishSwatches() {
    if (!state.style) return;
    var finishes = FINISHES[state.style];
    var plateHandle = PLATES[state.style]['1G'].handle;
    var plateProduct = state.products[plateHandle];

    dom.finishCards.classList.toggle('has-4-finishes', finishes.length === 4);

    var html = '';
    for (var i = 0; i < finishes.length; i++) {
      var f = finishes[i];
      var selected = state.finish === f.variant ? ' is-selected' : '';
      var img = getWithSwitchImage(plateProduct, f.variant);
      html += '<button class="push-bundle__finish-card' + selected + '" ' +
        'data-variant="' + f.variant + '" data-display="' + f.display + '" data-code="' + f.code + '">' +
        '<div class="push-bundle__finish-card-img">' +
          (img ? '<img src="' + getSizedUrl(img, 800) + '" alt="' + f.display + '" loading="lazy">' : '') +
        '</div>' +
        '<span class="push-bundle__finish-card-label">' + f.display + '</span>' +
      '</button>';
    }
    dom.finishCards.innerHTML = html;
  }

  function onFinishClick(e) {
    var swatch = e.target.closest('[data-variant]');
    if (!swatch) return;
    selectFinish(swatch);
  }

  function selectFinish(swatch) {
    state.finish = swatch.dataset.variant;
    state.finishDisplay = swatch.dataset.display;
    state.finishCode = swatch.dataset.code;
    renderFinishSwatches();
    setStep(3);
  }

  // -- Set Cards --
  function renderSetCards() {
    if (!state.style || !state.finish) return;
    var plates = PLATES[state.style];
    var gangs = ['1G', '2G', '3G', '4G'];
    var html = '';

    for (var i = 0; i < gangs.length; i++) {
      var gang = gangs[i];
      var info = plates[gang];
      var product = state.products[info.handle];
      if (!product) continue;

      var variant = getVariant(product, state.finish);
      if (!variant) continue;

      var switchProduct = state.products[SWITCH_HANDLE];
      var switchVariant = switchProduct ? getVariant(switchProduct, state.finish) : null;
      var switchPrice = switchVariant ? switchVariant.price : 0;
      var setPrice = variant.price + (info.switches * switchPrice);
      var img = getWithSwitchImage(product, state.finish);

      html += '<div class="push-bundle__set-card" data-gang="' + gang + '">' +
        '<div class="push-bundle__set-card-img">' +
          (img ? '<img src="' + getSizedUrl(img, 800) + '" alt="' + info.label + ' Set" loading="lazy">' : '') +
        '</div>' +
        '<div class="push-bundle__set-card-info">' +
          '<h3 class="push-bundle__set-card-title">' + info.label + '</h3>' +
          '<p class="push-bundle__set-card-contents">1 plate + ' + info.switches + ' switch' + (info.switches > 1 ? 'es' : '') + '</p>' +
          '<p class="push-bundle__set-card-price">' + formatMoney(setPrice) + '</p>' +
        '</div>' +
        '<div class="push-bundle__qty-control" data-action="add-set" data-key="' + gang + '">' +
          buildAddBtnHTML() +
        '</div>' +
      '</div>';
    }
    dom.setGrid.innerHTML = html;
  }

  // -- Upsell Cards --
  function renderUpsellCards() {
    if (!state.style || !state.finish) return;
    var items = UPSELL[state.style];
    var html = '';
    var lastGang = null;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var product = state.products[item.handle];
      if (!product) continue;

      var variant = getVariant(product, state.finish);
      if (!variant) continue;

      if (item.gang !== lastGang) {
        var sectionLabel = item.gang === '1G' ? 'Single Gang' : 'Double Gang';
        html += '<h4 class="push-bundle__upsell-section-header">' + sectionLabel + '</h4>';
        lastGang = item.gang;
      }

      var img = getVariantImage(variant, product);

      html += '<div class="push-bundle__upsell-card" data-upsell="' + item.handle + '">' +
        '<div class="push-bundle__upsell-card-img">' +
          (img ? '<img src="' + getSizedUrl(img, 300) + '" alt="' + item.label + '" loading="lazy">' : '') +
        '</div>' +
        '<div class="push-bundle__upsell-card-info">' +
          '<h3 class="push-bundle__upsell-card-title">' + item.label + '</h3>' +
          '<p class="push-bundle__upsell-card-price">' + formatMoney(variant.price) + '</p>' +
        '</div>' +
        '<div class="push-bundle__qty-control" data-action="add-upsell" data-key="' + item.handle + '">' +
          buildAddBtnHTML() +
        '</div>' +
      '</div>';
    }
    dom.upsellGrid.innerHTML = html;
    dom.upsellSubtitle.textContent = 'Toggles, outlets, and open covers in ' +
      state.style + ' · ' + state.finishDisplay + ' — for the spots without push buttons.';
  }

  // -- Quantity Controls --
  function buildAddBtnHTML() {
    return '<button class="push-bundle__add-btn" type="button">ADD</button>';
  }

  function onGridClick(e) {
    var control = e.target.closest('.push-bundle__qty-control');
    if (!control) return;
    var btn = control.querySelector('.push-bundle__add-btn');
    if (!btn || btn.disabled) return;

    var action = control.dataset.action;
    var key = control.dataset.key;

    if (action === 'add-set') {
      addSetToCart(key, btn);
    } else if (action === 'add-upsell') {
      addUpsellToCart(key, btn);
    }
  }

  // -- Cart Adds (one click = one set / one upsell plate into cart) --
  function addSetToCart(gang, btn) {
    var info = PLATES[state.style][gang];
    var plateProduct = state.products[info.handle];
    var plateVariant = plateProduct ? getVariant(plateProduct, state.finish) : null;
    var switchProduct = state.products[SWITCH_HANDLE];
    var switchVariant = switchProduct ? getVariant(switchProduct, state.finish) : null;
    if (!plateVariant || !switchVariant) {
      flashError(btn);
      return;
    }

    var items = [
      { id: plateVariant.id, quantity: 1 },
      { id: switchVariant.id, quantity: info.switches }
    ];

    var plateLabel = state.style + ' ' + info.label + ' Plate';
    var switchLabel = info.switches === 1
      ? '1 Push Button Switch'
      : info.switches + ' Push Button Switches';

    var popdown = {
      title: 'Bundle added — ',
      detail: plateLabel + ' + ' + switchLabel,
      images: [
        plateProduct && plateProduct.images && plateProduct.images[0] ? plateProduct.images[0] : null,
        switchProduct && switchProduct.images && switchProduct.images[0] ? switchProduct.images[0] : null
      ]
    };

    commitToCart(items, btn, popdown, function () {
      if (!state.firstSetAdded) {
        state.firstSetAdded = true;
        revealUpsell();
      }
    });
  }

  function addUpsellToCart(handle, btn) {
    var product = state.products[handle];
    var variant = product ? getVariant(product, state.finish) : null;
    if (!variant) {
      flashError(btn);
      return;
    }

    var label = '';
    var items = UPSELL[state.style];
    for (var i = 0; i < items.length; i++) {
      if (items[i].handle === handle) { label = state.style + ' ' + items[i].label; break; }
    }

    var popdown = {
      title: 'Added — ',
      detail: label + ' · ' + state.finishDisplay,
      images: [product && product.images && product.images[0] ? product.images[0] : null]
    };

    commitToCart([{ id: variant.id, quantity: 1 }], btn, popdown);
  }

  function commitToCart(items, btn, popdown, onDone) {
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Cart error');
      return r.json();
    })
    .then(function () {
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      btn.textContent = 'Added ✓';

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('theme:cart:change', {
            detail: { cart: cart },
            bubbles: true
          }));
          showPopdown(popdown);
        });

      setTimeout(function () {
        btn.classList.remove('is-added');
        btn.disabled = false;
        btn.textContent = 'ADD';
      }, 2200);

      if (typeof onDone === 'function') onDone();
    })
    .catch(function () {
      btn.classList.remove('is-loading');
      btn.disabled = false;
      btn.textContent = 'Try again';
      setTimeout(function () { btn.textContent = 'ADD'; }, 2500);
    });
  }

  function flashError(btn) {
    var original = btn.textContent;
    btn.textContent = 'Error';
    setTimeout(function () { btn.textContent = original; }, 2000);
  }

  function revealUpsell() {
    if (dom.upsell.style.display !== 'none') return;
    dom.upsell.style.display = '';
    dom.upsell.classList.add('is-entering');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        dom.upsell.classList.remove('is-entering');
      });
    });
  }

  // -- Theme Popdown --
  function showPopdown(data) {
    var popdownEl = document.querySelector('[data-product-add-popdown-wrapper]');
    if (!popdownEl) return;

    var imagesHtml = '';
    var firstImg = data.images[0] ? '<img src="' + getSizedUrl(data.images[0], 80) + '" alt="">' : '';
    var secondImg = data.images[1] ? '<img src="' + getSizedUrl(data.images[1], 80) + '" alt="">' : '';
    imagesHtml = firstImg +
      (firstImg && secondImg ? '<span class="push-bundle-popdown__plus">+</span>' : '') +
      secondImg;

    popdownEl.innerHTML =
      '<div class="product__popdown__outer" role="alertdialog" aria-labelledby="dialogTitle">' +
        '<div class="product__popdown__textbar">' +
          '<span class="product__popdown__title product__popdown__title--bold">' + data.title + '</span>' +
          '<span class="product__popdown__title">' + data.detail + '</span>' +
        '</div>' +
        '<div class="wrapper !my-auto">' +
          '<div class="product__popdown__inner">' +
            '<div class="product__popdown__close">' +
              '<button class="popdown__close__inner" aria-label="Close" data-close-popdown>' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><line x1="2" y1="2" x2="14" y2="14"/><line x1="14" y1="2" x2="2" y2="14"/></svg>' +
              '</button>' +
            '</div>' +
            '<div class="product__popdown__image push-bundle-popdown__images">' + imagesHtml + '</div>' +
            '<div class="product__popdown__cart__wrapper">' +
              '<a href="/cart" class="product__popdown__cart btn-text-thick-line" data-drawer-toggle="drawer-cart">View cart</a>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';

    popdownEl.classList.add('is-visible');

    var closeBtn = popdownEl.querySelector('[data-close-popdown]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        popdownEl.classList.remove('is-visible');
      });
    }

    clearTimeout(showPopdown._timer);
    showPopdown._timer = setTimeout(function () {
      popdownEl.classList.remove('is-visible');
    }, 5000);
  }

  // -- Stepper Click --
  function onStepperClick(e) {
    var step = e.target.closest('.push-bundle__stepper-step');
    if (!step) return;
    var target = parseInt(step.dataset.step);
    if (target >= state.step) return;

    // Keep the finish selection on back-navigation — selectStyle()
    // clears it only when the user picks a *different* style.
    setStep(target);
  }

  // -- Helpers --
  function getVariant(product, finishVariant) {
    if (!product || !product.variants) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].title === finishVariant) return product.variants[i];
    }
    // No silent fallback to variants[0] — a title mismatch returns null
    // so callers skip the card or fire flashError instead of adding the
    // wrong finish to the cart.
    return null;
  }

  function getVariantImage(variant, product) {
    if (variant && variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }
    if (product && product.images && product.images.length) {
      return product.images[0];
    }
    return null;
  }

  function getWithSwitchImage(product, finishVariant) {
    if (!product) return null;
    var variant = getVariant(product, finishVariant);
    if (!variant) return null;
    var variantSrc = (variant.featured_image && variant.featured_image.src) ? variant.featured_image.src : null;
    if (variantSrc) {
      var fixtureUrl = variantSrc.replace(/-Ob\.\w+/, '-Oh-W.jpg');
      if (fixtureUrl !== variantSrc) return fixtureUrl;
    }
    return getVariantImage(variant, product);
  }

  function getSizedUrl(url, size) {
    if (!url) return '';
    return url.replace(/(\.[a-z]+)(\?.*)?$/i, '_' + size + 'x$1$2');
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // -- Boot --
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
